module.exports = __webpack_public_path__ + "static/media/2016_conf_Manage_Global_Design_Teams.279ecdc5.png";